import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Parking: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 30.95 43.39">
            <g>
                <path fill={color} d="M22.86,7.91H7.8v10.02h15.06V7.91ZM20.65,15.71h-10.64v-5.59h10.64v5.59Z"/>
                <path fill={color} d="M0,0v40.81l1.86-1.76V1.86h27.22v14.42c0,4.24-3.45,7.69-7.69,7.69H7.93v17.55H1.96s-1.96,1.86-1.96,1.86v.02h9.8v-17.56h11.6c5.27,0,9.55-4.28,9.55-9.55V0H0Z"/>
            </g>
        </svg>
    );
};

export default Parking;
